import React from 'react';
//import env from '../../config/env'; 
/*modify 2020-11-06 1.發布按鈕改送出審核 2.預覽搬移到充腎和按鈕旁*/
function PreviewButton(props){
    const {cid, themNum} = props;
    const style= {marginRight:'5px'};
    //const url= `${env.Website}/managerweb/${cid}/preview/${themNum}`;
    return(
     
        <div>
            {themNum && cid && 
                <div>
                  <div className="mangerweb-pb-1">
                  <style>
                     {`.color-button-des {color: var(--ck-color-base-error);font-weight: 800;} .scroll-to-top2 { position: fixed; width: 11.75rem; height: 4.75rem;  text-align: center;  color: rgb(255, 255, 255); line-height: 46px; left: 1rem; opacity: 0.999985; z-index: 99;}`}
                  </style>
                  <span className="color-button-des">審核通過前，您的徵才網頁將暫時預設為人力銀行公版頁面<br/><br/></span>
                    <a href={`/${cid}`} target='_blank' rel="noopener noreferrer"><button className='btn btn-primary' style={style}>送出審核</button></a>
                    <a href={`/managerweb/${cid}/preview/${themNum}`} target='_blank' rel="noopener noreferrer"><span className='btn btn-primary'>預覽</span></a>
                  </div>
                  <a href={`/managerweb/${cid}/preview/${themNum}`} target='_blank' rel="noopener noreferrer" className="scroll-to-top2 rounded scroll-to-top-bottom">
                      <button className="btn btn-warning rounded" style={{color:'#634a0b',fontSize: '24px',fontWeight: '800',padding:'12px 35px'}}>
                          <span>頁面預覽</span>
                      </button>
                    </a>                  
                </div>
                
            }
      
        </div>
    )
   
    
}

export default PreviewButton;


